import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.header.menu.configure-board-item.display-text',
		defaultMessage: 'Configure board',
		description: 'Dropdown menu item which opens up Column status mapping to configure board',
	},
});
